import type { ReactNode } from 'react'

import { Translation, useSafetyTranslation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { CockpitBreadcrumb } from '../../../components/cockpitBreadcrumb'
import type { IAttentionStatusesCrumb } from '../../types'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.attentionStatuses.breadcrumb

interface IAttentionStatusesBreadcrumbProps {
  crumbs: IAttentionStatusesCrumb[]
  /** Label of the level the user stands on; rendered as plain text after the crumbs. */
  current?: string
  /** Drawn right before `current`, e.g. the level the status stands at. */
  currentBadge?: ReactNode
  /** `-1` returns to the status list; any other index is the crumb of that position. */
  onNavigate: (index: number) => void
}

/**
 * The drill-down's way back: `All statuses` first, then one step per level walked into. Only the
 * levels above the current one are links — the level itself is where the user already is.
 */
export const AttentionStatusesBreadcrumb = ({
  crumbs,
  current,
  currentBadge,
  onNavigate,
}: IAttentionStatusesBreadcrumbProps) => {
  const t = useSafetyTranslation()

  return (
    <CockpitBreadcrumb
      rootLabel={<Translation span text={KEYS.allStatuses} />}
      ariaLabel={t(KEYS.ariaLabel)}
      crumbs={crumbs}
      current={current}
      currentBadge={currentBadge}
      onNavigate={onNavigate}
    />
  )
}

AttentionStatusesBreadcrumb.displayName = 'AttentionStatusesBreadcrumb'
